import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tissueBtn", "tissueTitle", "observationText", "indicator"]

  connect() {
    this.selectTissue("LS");
    this.updateIndicators();
  }

  showObservation(event) {
    this.tissueBtnTargets.forEach(btn => {
      btn.classList.remove('active', 'bg-blue-200', 'border-2', 'border-blue-500');
    });

    event.currentTarget.classList.add('active', 'bg-blue-200', 'border-2', 'border-blue-500');

    const tissueCode = event.currentTarget.dataset.tissue;
    this.selectTissue(tissueCode);
  }

  selectTissue(tissue) {
    const tissueKey = tissue.toLowerCase();

    const titleMap = {
      'ls': 'Labio Superior',
      'pd': 'Paladar Duro',
      'pb': 'Paladar Blando',
      'of': 'Orofaringe',
      'myd': 'Mucosa Yugal Derecha',
      'myi': 'Mucosa Yugal Izquierda',
      'l': 'Lengua',
      'sl': 'Sublingual',
      'li': 'Labio Inferior',
      'cd': 'Comisura Derecha',
      'ci': 'Comisura Izquierda'
    };

    this.tissueTitleTarget.textContent = titleMap[tissueKey];

    const hiddenField = document.getElementById(`soft_tissue_${tissueKey}_observation`);
    const observationValue = hiddenField ? hiddenField.dataset.value : '';

    this.observationTextTarget.textContent = observationValue || 'Sin observaciones';

    this.observationTextTarget.scrollTop = 0;

    this.tissueBtnTargets.forEach(btn => {
      if (btn.dataset.tissue.toLowerCase() === tissueKey) {
        btn.classList.add('active', 'bg-blue-200', 'border-2', 'border-blue-500');
      }
    });
  }

  updateIndicators() {
    this.indicatorTargets.forEach(indicator => {
      const tissueCode = indicator.dataset.tissue;
      const tissueKey = tissueCode.toLowerCase();
      const hiddenField = document.getElementById(`soft_tissue_${tissueKey}_observation`);
      const observationValue = hiddenField ? hiddenField.dataset.value : '';

      if (observationValue && observationValue.trim() !== '') {
        indicator.style.display = 'block';
      } else {
        indicator.style.display = 'none';
      }
    });
  }
}
